<template>
  <v-content fill-height id="list-project" class="project page">
    <v-container class="mt-2 text-xs-center">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h1>My Projects</h1>
        </v-flex>
      </v-layout>
    </v-container>
    <Loading v-if="loading"/>
    <v-container fluid v-else>
      <v-layout row wrap v-if="projectsMedium">
        <v-flex xs12 sm6 md3 align-center v-for="project in projectsMedium" :key="project.id">
          <v-card color="teal darken-4" class="white--text mx-2 mt-2">
            <v-layout row>
              <v-flex xs7>
                <v-card-title primary-title>
                  <div>
                    <div class="headline">{{ project.title }}</div>
                    <div>({{ project.year }})</div>
                  </div>
                </v-card-title>
              </v-flex>
              <v-flex xs5>
                <v-img v-bind:src="project.image_url" height="125px" contain class="my-1 mx-1"></v-img>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-text>
              <a v-bind:href="project.github_url" target="_blank" v-if="project.github_url">
                <v-btn color="cyan darken-1" dark>Github
                  <v-icon small>fab fa-github</v-icon>
                </v-btn>
              </a>
              <a v-bind:href="project.project_url" target="_blank" v-if="project.project_url">
                <v-btn color="green darken-3" dark>View
                  <v-icon small>fas fa-eye</v-icon>
                </v-btn>
              </a>
              <ProjectDetails v-bind:project="project"/>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="projectsEasy">
        <v-flex xs12 sm6 md3 align-center v-for="project in projectsEasy" :key="project.id">
          <v-card color="teal darken-4" class="white--text mx-2 mt-2">
            <v-layout row>
              <v-flex xs7>
                <v-card-title primary-title>
                  <div>
                    <div class="headline">{{ project.title }}</div>
                    <div>({{ project.year }})</div>
                  </div>
                </v-card-title>
              </v-flex>
              <v-flex xs5>
                <v-img v-bind:src="project.image_url" height="125px" contain class="my-1 mx-1"></v-img>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-text>
              <a v-bind:href="project.github_url" target="_blank" v-if="project.github_url">
                <v-btn color="cyan darken-1" dark>Github
                  <v-icon small>fab fa-github</v-icon>
                </v-btn>
              </a>
              <a v-bind:href="project.project_url" target="_blank" v-if="project.project_url">
                <v-btn color="green darken-3" dark>View
                  <v-icon small>fas fa-eye</v-icon>
                </v-btn>
              </a>
              <ProjectDetails v-bind:project="project"/>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";
import ProjectDetails from "./ProjectDetails";
export default {
  components: { Loading, ProjectDetails },
  data() {
    return {
      loading: true,
      projectsEasy: [],
      projectsMedium: []
    };
  },
  mounted() {
    axios
      .get("https://wicaker.herokuapp.com/api/v1/projects")
      .then(res => {
        this.projectsEasy = res.data.filter(
          project => project.level === "easy"
        );
        this.projectsMedium = res.data.filter(
          project => project.level === "medium"
        );
        return (this.loading = false);
      })
      .catch(err => console.log(err));
  }
};
</script>

<style>
.white-space-pre {
  white-space: pre-wrap;
}
</style>
